var MDB = window.MDB || {};;
MDB.SettingsApi = MDB.SettingsApi || {};
MDB.SettingsApi.Edit = MDB.SettingsApi.Edit || {};

(function() {

    var _config,
        _testUrl,
        _tokenTypes = {
            oauthToken: "0",
            staticToken: "1",
            basicToken: "2",
            awsToken: "3"
        };

    $.extend(MDB.SettingsApi.Edit, {
    	boot: function(config) {
    		var targetSelection = $('#TargetType');
            _testUrl = $('#url-label');

            targetSelection.on('change', function(){ 
                setInputFields() 
            });
                    
            targetSelection.trigger('change');

            //Init numeric inputs
            $('.mdb-numeric-field').mdbNumericInput();
            
            MDB.SettingsApi.Edit.initApiTest(config.testApiUrl);

            function setInputFields() {
                var basic = $('#credentials');
                var oauth = $('#oauth-settings');
                var aws = $('#aws-settings');

                var settings = [oauth, aws, basic];
                
                var credentialsEditor = $('#credentials .config-editor');
                var credentialsRows = credentialsEditor.find('.config-value-row');

                if(targetSelection.val() == _tokenTypes.oauthToken) {

                    basic.show();
                    oauth.show();
                    aws.find('input').val('');
                    aws.hide();

                } else if(targetSelection.val() == _tokenTypes.staticToken) {

                    settings.forEach(function (selector) {
                        selector.hide();
                    });

                } else if(targetSelection.val() == _tokenTypes.basicToken){ 
                    var childrenNr = credentialsEditor.children().length;
                    
                    if(childrenNr < 2) {
                        MDB.ConfigEditor.addRow(credentialsEditor, 2 - childrenNr);
                    }

                    //Remove all but the first 2 rows
                    credentialsRows.filter(':gt(1)').remove();
                    
                    //Take first two elements, if we have less than 2, we'll have to add them manually
                    credentialsRows = $(credentialsRows.selector);

                    oauth.hide();
                    aws.hide();
                    basic.show();

                    setUsernameAndPassword();

                } else if (targetSelection.val() == _tokenTypes.awsToken) {

                    oauth.hide();
                    basic.hide();
                    aws.show();
                }

                if((targetSelection.val() != _tokenTypes.basicToken) && (targetSelection.val() != _tokenTypes.oauthToken)) {
                    credentialsEditor.find('.mdb-icon-btn.delete').click();
                }

                MDB.ConfigEditor.reIndexRows(credentialsEditor);
            }

            function setUsernameAndPassword() {
                var configEditor = $('#credentials .config-editor');
                var keys = configEditor.find('input[data-type="key"]');
                var values = configEditor.find('input[data-type="value"]');

                keys.eq(0).val('Username');
                keys.eq(1).val('Password');
                values.eq(1).prop('type', 'password');
            }

    	},
    	initApiTest: function(testUrl) {

            var sendBtn = $('#test-api-btn');

            sendBtn.click(function(e) {
                var url = $('#api-url').val();
                e.preventDefault();

                if(url == '') {
                    MDB.Notify.bootstrapDanger('Please provide a url to test the api target with.');
                } else {
                    MDB.SettingsApi.Edit.testApi(url, testUrl);
                }
            });

        },
        testApi: function(targetUrl, testUrl) {
            var responseTarget = $('#api-response-text');
            responseTarget.text('');

            var model = {
                id: $('#Id').val(),
                method: $('#HttpMethod').val(),
                url: targetUrl
            };

            MDB.sendAjaxRequest(testUrl, model, "POST").done(function(response) {
                if(response.errors.length > 0) {
                    MDB.Notify.bootstrapDanger(response.errors);
                } else {
                    MDB.Notify.bootstrapSuccess('Api tested successfully');
                    responseTarget.text(JSON.stringify(JSON.parse(response.value), null, 4));
                }
            });
        }
    });
})();